import React, {useEffect, useRef, useState} from "react";
import {Typography, Button, Box} from "@mui/material";

const TextWithReadMore = ({text, maxCharCount, onReadMore}) => {
  text=text.replace(/\s+/g, ' ');
  const [overflowed, setOverFlowed] = useState(false);
  const [numLines, setNumLines] = useState(4);
  const cardRef = React.useRef();
  React.useEffect(() => {
    const cardHeight = cardRef.current.clientHeight;
    const lineHeight = parseInt(window.getComputedStyle(cardRef.current).lineHeight);
    const hasOverflow = cardRef.current.scrollHeight > cardRef.current.clientHeight;
    const numLines = Math.floor(cardHeight / lineHeight);
    // console.log("number of line ", numLines, cardHeight, hasOverflow, lineHeight);
    setOverFlowed(hasOverflow);
    setNumLines(numLines);
    // setNumLines(numLines);
  }, []);
  const contentStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: numLines,
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "relative",

  };

  const readMoreStyle = {
    position: "absolute",
    bottom: 0,
    right: 0,
    background: "white",
    padding: "0 4px",
  };
  function isMobile() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const minSize = 450;
    return screenWidth <= minSize;
  }
  return (
    <Box>
      <Typography style={contentStyle} ref={cardRef} sx={{position: "relative", fontSize:isMobile()?"12px":"14px", color: "#616060", fontWeight: isMobile()?"300":"400", fontFamily: "Inter", height: "100%", lineHeight:isMobile()?"1.4":"1.7"}} color="text.secondary" gutterBottom variant="body1">
        {isMobile() && (text?.slice(0,60)+"..")}
        {!isMobile() && (text?.slice(0,750)+"..")}
      </Typography>
      {/* removed overflow */}
      {(
        <Button
          onClick={onReadMore}
          style={{
            color: "black",
            fontWeight: "500",
            fontSize:isMobile()?"9px":"11px",
            padding: "0",
            // position: "absolute",
            // bottom: "-10px",
            // left: "0",
            // zIndex: "10",
          }}
        >
          Read More
        </Button>
      )}
    </Box>
  );
};

export default TextWithReadMore;
